var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProfileCircle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M12.6249 13.8125C12.552 13.8021 12.4583 13.8021 12.3749 13.8125C10.5416 13.75 9.08325 12.25 9.08325 10.4062C9.08325 8.52081 10.6041 6.98956 12.4999 6.98956C14.3853 6.98956 15.9166 8.52081 15.9166 10.4062C15.9062 12.25 14.4583 13.75 12.6249 13.8125Z",
    stroke: "#1B3F7A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.34,
    d: "M19.5209 20.6875C17.6667 22.3854 15.2084 23.4167 12.5001 23.4167C9.79175 23.4167 7.33341 22.3854 5.47925 20.6875C5.58341 19.7083 6.20841 18.75 7.323 18C10.1772 16.1042 14.8438 16.1042 17.6772 18C18.7917 18.75 19.4167 19.7083 19.5209 20.6875Z",
    stroke: "#1B3F7A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4999 23.4166C18.2529 23.4166 22.9166 18.7529 22.9166 13C22.9166 7.24701 18.2529 2.58331 12.4999 2.58331C6.74695 2.58331 2.08325 7.24701 2.08325 13C2.08325 18.7529 6.74695 23.4166 12.4999 23.4166Z",
    stroke: "#1B3F7A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileCircle);
export default __webpack_public_path__ + "static/media/profile-circle.7b61d811c8a20810a8f22d47f17790bd.svg";
export { ForwardRef as ReactComponent };